import { useTranslation } from "react-i18next";
import { CheckoutOtpForm } from "./checkout-otp-form";

interface NewUserOtpOverlayProps {
  onSubmit: (code: string) => void;
  onResend: () => void;
  isLoading?: boolean;
  error?: string | null;
  resendCount: number;
  cooldownEnd: number | null;
  resetSignal?: number;
  bannerMessage?: string;
  isSessionExpired?: boolean;
  onRetry?: () => void;
  // Confirming the code here commits the order, so the CTA copy reflects the next step:
  // free baskets land on the thank-you page; paid baskets get redirected to the payment provider.
  isFreeCart?: boolean;
}

export const NewUserOtpOverlay = ({
  onSubmit,
  onResend,
  isLoading,
  error,
  resendCount,
  cooldownEnd,
  resetSignal,
  bannerMessage,
  isSessionExpired,
  onRetry,
  isFreeCart = false,
}: NewUserOtpOverlayProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center py-6">
      <div className="fade-in slide-in-from-bottom-4 w-full max-w-lg animate-in fill-mode-both duration-500">
        <div className="mb-6 text-center">
          <h2 className="font-serif text-2xl lg:text-3xl">
            {t("VOUCHERS_DISTRIBUTION.PHONE_AUTH.NEW_USER_OTP_TITLE")}
          </h2>
          <p className="mt-2 text-muted-foreground">{t("VOUCHERS_DISTRIBUTION.PHONE_AUTH.NEW_USER_OTP_DESCRIPTION")}</p>
        </div>
        <CheckoutOtpForm
          onSubmit={onSubmit}
          onResend={onResend}
          isLoading={isLoading}
          error={error}
          resendCount={resendCount}
          cooldownEnd={cooldownEnd}
          purpose="registration"
          hideBanner={!bannerMessage}
          bannerMessage={bannerMessage}
          resetSignal={resetSignal}
          isSessionExpired={isSessionExpired}
          onRetry={onRetry}
          submitLabelKey={
            isFreeCart
              ? "VOUCHERS_DISTRIBUTION.PHONE_AUTH.CONFIRM_CODE_AND_ORDER_FREE"
              : "VOUCHERS_DISTRIBUTION.PHONE_AUTH.CONFIRM_CODE_AND_PAY"
          }
        />
      </div>
    </div>
  );
};
